import Vue from 'vue'
import Router from 'vue-router'
import Start from 'common/components/start'

const GradeWork = (reslove) => {
  import(/* webpackChunkName:"grading" */ 'homework/pages/grade/grading').then((module) => {
    reslove(module)
  })
}
const TeaModifyList = (reslove) => {
  import(/* webpackChunkName:"teaModifyList" */ 'homework/pages/teaModifyList/teaModifyList').then((module) => {
    reslove(module)
  })
}
const StuDetail = (reslove) => {
  import(/* webpackChunkName:"stuDetail" */ 'homework/pages/stuDetail/stuDetail').then((module) => {
    reslove(module)
  })
}
const StuWriting = (reslove) => {
  import(/* webpackChunkName:"stuWriting" */ 'homework/pages/stuWriting/stuWriting').then((module) => {
    reslove(module)
  })
}
const HistoryWork = (reslove) => {
  import(/* webpackChunkName:"historywork" */ 'homework/pages/historywork/historywork').then((module) => {
    reslove(module)
  })
}
const ChoseClass = (reslove) => {
  import(/* webpackChunkName:"choseClass" */ 'homework/pages/choseClass/choseClass').then((module) => {
    reslove(module)
  })
}
const ClassList = (reslove) => {
  import(/* webpackChunkName:"classList" */ 'homework/pages/classList/classList').then((module) => {
    reslove(module)
  })
}
// const ChoseDate = (reslove) => {
//   import(/* webpackChunkName:"choseDate" */ 'homework/pages/choseDate/choseDate').then((module) => {
//     reslove(module)
//   })
// }
const ChoseDate = (reslove) => {
  import(/* webpackChunkName:"choseDate" */ 'homework/pages/dates/index').then((module) => {
    reslove(module)
  })
}
const PublishTea = (resolve) => {
  import(/* webpackChunkName:"publishTea" */ 'homework/pages/publishTea/publishTea').then((module) => {
    resolve(module)
  })
}
const ShareWork = (resolve) => {
  import(/* webpackChunkName:"shareWork" */ 'homework/pages/shareWork/shareWork').then((module) => {
    resolve(module)
  })
}

const Evaluation = (resolve) => {
  import(/* webpackChunkName:"evaluation" */ 'homework/pages/evaluation/evaluation').then((module) => {
    resolve(module)
  })
}
const EvaluationMobile= (resolve) => {
  import(/* webpackChunkName:"EvaluationMobile" */ 'homework/pages/evaluation/newEvaluation').then((module) => {
    resolve(module)
  })
}
const EvaluationPc = (resolve) => {
  import(/* webpackChunkName:"evaluationPc" */ 'homework/pages/evaluationPc/stuworkDetail').then((module) => {
    resolve(module)
  })
}
const WorkDetail = (resolve) => {
  import(/* webpackChunkName:"workDetail" */ 'homework/pages/workDetail/workDetail').then((module) => {
    resolve(module)
  })
}
const ComplainWork = (resolve) => {
  import(/* webpackChunkName:"stuComplain" */ 'homework/pages/stuComplain/stuComplain.vue').then((module) => {
    resolve(module)
  })
}
const RepeatReport = (reslove) => {
  import(/* webpackChunkName:"repeatReport" */ 'homework/pages/repeatReport/repeatReport.vue').then((module) => {
    reslove(module)
  })
}
const ShareWorkDetail = (reslove) => {
  import(/* webpackChunkName:"shareWorkDetail" */ 'homework/pages/shareWork/shareWorkDetail').then((module) => {
    reslove(module)
  })
}
const AttachDetail = (reslove) => {
  import(/* webapckChunkName:"attachDetail" */ 'homework/pages/attachDetail/attachDetail').then((module) => {
    reslove(module)
  })
}
const PreviewVideoFile = (reslove) => {
  import(/* webapckChunkName:"previewVideoFile" */ 'homework/pages/previewVideo/previewVideo.vue').then((module) => {
    reslove(module)
  })
}
const SearchDetail = (reslove) => {
  import(/* webpackChunkName:"seachDetail" */ 'homework/components/mobile/searchDetail/searchDetail').then((module) => {
    reslove(module)
  })
}
const AppealIntro = (reslove) => {
  import(/* webpackChunkName:"peerule" */ 'homework/pages/grade/peerrule').then((module) => {
    reslove(module)
  })
}
const scoreRule = (reslove) => {
  import(/* webpackChunkName:"scoreRules" */ 'homework/components/mobile/scoreRules/scoreRules').then((module) => {
    reslove(module)
  })
}
const levelTip = (reslove) => {
  import(/* webpackChunkName:"peerule" */ 'homework/pages/grade/levelTip').then((module) => {
    reslove(module)
  })
}
const notStart = (reslove) => {
  import(/* webpackChunkName:"notStart" */ 'homework/pages/notStart/notStart').then((module) => {
    reslove(module)
  })
}
Vue.use(Router)
const router = new Router({
  routes: [{
    path: '/start',
    component: Start
  },
  {
    path: '/stuWriting/:userID/:homeworkID',
    component: StuWriting,
    meta: {
      title: '写作业'
    }
  },
  {
    path: '/publishTea/:userID',
    component: PublishTea,
    meta: {
      title: '发布作业'
    }
  },
  {
    path: '/publishTea/:userID/:homeworkID',
    component: PublishTea,
    meta: {
      title: '发布作业'
    }
  },
  {
    path: '/choseDate/:type/:status/:userID/:classID',
    component: ChoseDate,
    meta: {
      title: '选择日期'
    }
  },
  {
    path: '/choseClass/:userID',
    component: ChoseClass,
    meta: {
      title: '选择班级'
    }
  },
  {
    path: '/classList/:userID',
    component: ClassList,
    meta: {
      title: '参与班级'
    }
  },
  {
    path: '/teaModifyList/:userID/:homeworkID',
    component: TeaModifyList,
    children: [{
      path: 'search',
      component: SearchDetail
    }],
    meta: {
      title: 'm.individualAssignment'
    }
  },
  {
    path: '/teaworkDetails/:teaID/:homeworkID/:userID',
    component: GradeWork,
    meta: {
      title: '批阅作业'
    }
  },
  {
    path: '/stuDetail/:userID/:homeworkID',
    component: StuDetail,
    meta: {
      title: '作业详情'
    }
  },
  {
    path: '/shareWork/:userID/:homeworkID/:mutual/:role',
    component: ShareWork,
    meta: {
      title: '共享作业'
    }
  },
  {
    path: '/historywork/:teaID/:homeworkID/:userID',
    component: HistoryWork,
    meta: {
      title: '历史作业'
    }
  },
    // 学生互评
  {
    path: '/evaluation/:index/:peerReviewID/:userID/:homeworkID',
    component: Evaluation,
    meta: {
      title: 'm.evaluationWork'
    }
  },
  {
    path: '/EvaluationMobile/:index/:peerReviewID/:userID/:homeworkID/:currentUser',
    component: EvaluationMobile,
    meta: {
      title: 'm.evaluationWork'
    }
  },
  {
    path: '/evaluationStudent/:teaID/:homeworkID/:userID',
    component: EvaluationPc,
    meta: {
      title: '互评作业详情'
    }
  },
  {
    path: '/workDetail/:userID/:homeworkID/:role',
    component: WorkDetail,
    meta: {
      title: '作业详情'
    }
  },
  {
    path: '/submitComplain/:homeworkID',
    component: ComplainWork,
    meta: {
      title: '申诉作业'
    }
  },
  {
    path: '/repeatReport/:userID/:homeworkID/:stuUserID',
    component: RepeatReport
  },
  {
    path: '/shareWorkDetail/:teaID/:homeworkID/:userID/:stuHomeworkID',
    component: ShareWorkDetail,
    meta: {
      title: '作业详情'
    }
  },
  {
    name: 'attachDetail',
    path: '/attachDetail',
    component: AttachDetail
  },
  {
    name: 'previewVideo',
    path: '/previewVideo',
    component: PreviewVideoFile
  },
  {
    path: '/levelTip',
    component: levelTip,
    meta: {
      title: '等级和分值对应关系'
    }
  },
  {
    path: '/notStart/:userID/:homeworkID',
    component: notStart,
    meta: {
      title: '作业详情'
    }
  },
  {
    path: '/appealrule',
    component: AppealIntro,
    meta: {
      title: '评分规则'
    }
  },
  {
    path: '/scoreRule/:userID/:operation',
    component: scoreRule,
    meta: {
      title: '评分规则'
    }
  },
  {
    path: '/helpCenter',
    component: (reslove) => {
      import(/* webpackChunkName:"helpCenter" */ 'homework/pages/helpCenter/helpCenter').then((module) => {
        reslove(module)
      })
    }
  }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js